export default __webpack_public_path__ + "static/media/notio-logo-no-slogan.cb0dc627.svg";